// import React, { useState, useEffect } from "react";
// import { CiMoneyBill } from "react-icons/ci";
// import { BsCreditCard } from "react-icons/bs";
// import { HiUserPlus } from "react-icons/hi2";
// import { FaBoxArchive } from "react-icons/fa6";
// import Linechart from "../../components/LineChart/Linechart";
// import ProductList from "../../components/AdminDashboard/ProductList/ProductList ";
// import { BASE_URL } from "../../constant/api";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { MdOutlinePending } from "react-icons/md";
// import { IoIosCheckmark, IoIosClose } from "react-icons/io";

// function AdminBrands() {
//     const [productData, setProductData] = useState([]);
//     const [totalRevenue, setTotalRevenue] = useState([]);
//     const [totalProduct, setTotalProduct] = useState([]);
//     const [filter, setFilter] = useState("All");
//     const token = localStorage.getItem("token");

//     // Fetch products
//     const fetchTopSellingProducts = async () => {
//         try {
//             const response = await axios.get(`${BASE_URL}/products/`, {
//                 headers: {
//                     Authorization: `Token ${token}`,
//                 },
//             });
//             setProductData(response.data.Data || []);
//         } catch (error) {
//             console.error("Error fetching top-selling products:", error);
//         }
//     };

//     // Reusable function to fetch data
//     const fetchData = async (url, setter) => {
//         try {
//             const response = await axios.get(url, {
//                 headers: {
//                     Authorization: `Token ${token}`,
//                 },
//             });
//             setter(response.data.data || []);
//         } catch (error) {
//             console.error(`Error fetching data from ${url}:`, error);
//         }
//     };

//     useEffect(() => {
//         fetchTopSellingProducts();
//         fetchData(`${BASE_URL}/orders/superadmin/revenues/`, setTotalRevenue);
//         fetchData(`${BASE_URL}/products/superadmin/`, setTotalProduct);
//     }, [token]);

//     const statusMap = {
//         "All": "All",
//         "Approved": "Approved",
//         "Rejected": "Rejected",
//         "Pending": "Pending",
//     };

//     const filters = [
//         {
//             key: "all",
//             label: "All",
//             value: "All",
//             // icon: <CiMoneyBill size={20} />,
//         },
//         {
//             key: "approved",
//             label: "Approved",
//             value: "Approved",
//             icon: <IoIosCheckmark size={20} />,
//         },
//         {
//             key: "rejected",
//             label: "Rejected",
//             value: "Rejected",
//             icon: <IoIosClose size={20} />,
//         },
//         {
//             key: "pending",
//             label: "Pending",
//             value: "Pending",
//             icon: < MdOutlinePending size={20} />,
//         },
//     ];

//     return (
//         <div className="w-full">
//             {/* Filter options */}
//             <div className="flex w-full items-center justify-around border-b bg-white p-2">
//                 {filters.map((f) => (
//                     <div
//                         key={f.key}
//                         onClick={() => setFilter(f.value)}
//                         className={`flex cursor-pointer items-center gap-1 ${filter === f.value ? "font-bold text-brand-button-green-bg" : ""
//                             }`}
//                     >
//                         {f.icon}
//                         {f.label}
//                     </div>
//                 ))}
//             </div>

//             {/* Main content */}
//             <div className="flex flex-col my-5 gap-8 lg:flex-row">
//                 <div className="flex-1">
//                     <div className="rounded-xl text-sm">
//                         <div className="overflow-x-auto">
//                             {/* Table Header */}
//                             <div className="w-full space-y-4">
//                                 <div className="grid grid-cols-[1fr,2fr,1.5fr,2fr,1fr,1fr,1fr,1fr] font-medium text-brand-button-green-bg">
//                                     <div className="text-center">Item No</div>
//                                     <div className="text-center">Company Name</div>
//                                     <div className="text-center">Location</div>
//                                     <div className="text-center">Brand</div>
//                                     <div className="text-center">Status</div>
//                                     <div className="text-center">Approve</div>
//                                     <div className="text-center">Reject</div>
//                                     <div className="text-center">Actions</div>
//                                 </div>
//                             </div>

//                             {/* Table Content */}
//                             {productData
//                                 .filter((product) => (filter === "All" ? true : product.status === filter))
//                                 .map((product, index) => (
//                                     <div
//                                         key={product.id || index}
//                                         className="grid text-[#2F2E41] min-w-[1024px] grid-cols-[1fr,2fr,1.5fr,2fr,1fr,1fr,1fr,1fr] items-center gap-2 py-2"
//                                     >
//                                         {/* Row Data */}
//                                         <div className="border rounded-xl p-2 text-center">{index + 1}</div>
//                                         <div className="line-clamp-1 rounded-xl border p-2 text-center">{product.name}</div>
//                                         <div className="border p-2 rounded-xl text-center">{product.location}</div>
//                                         <div className="border p-2 rounded-xl text-center">{product.brand}</div>
//                                         <div className="border p-2 rounded-xl text-center">
//                                             {product.stock_status ? "Approve" : "Rejected"}
//                                         </div>
//                                         <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400 cursor-pointer">
//                                             Approve
//                                         </div>
//                                         <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400 cursor-pointer">
//                                             Reject
//                                         </div>
//                                         <div className="border p-2 rounded-xl text-center hover:bg-brand-primary text-brand-text-light hover:text-white transition ease-in-out duration-400">
//                                             <Link to={`/admin/product-details/${product.id}`}>View</Link>
//                                         </div>
//                                     </div>
//                                 ))}
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default AdminBrands




// import React, { useEffect, useState } from "react";
// import { MdOutlineAccountBalanceWallet } from "react-icons/md";
// import { RxLapTimer } from "react-icons/rx";
// import { FaUserCheck, FaUserSlash } from "react-icons/fa";
// import axios from "axios";
// import { BASE_URL, USER_URL } from "../../constant/api";
// import { Link } from "react-router-dom";

// function AdminBrands() {
//     const [filter, setFilter] = useState("All");
//     const [products, setProducts] = useState([]);
//     // const token = localStorage.getItem("token");
  
//     // Fetch products on component mount
//     useEffect(() => {
//       const fetchProducts = async () => {
//         try {
//           const response = await USER_URL.get(`/products/admin/brands/`, {
//             // headers: { Authorization: `Token ${token}` },
//           });
//           if (response.data?.Data) {
//             setProducts(response.data.Data);
//           }
//         } catch (error) {
//           console.error("Error fetching products:", error.message || error);
//         }
//       };
//       fetchProducts();
//     }, []);
  
//     // Toggle Approve/Reject status
//     const handleStatusToggle = (id) => {
//       setProducts((prevProducts) =>
//         prevProducts.map((product) => {
//           if (product.id === id) {
//             return {
//               ...product,
//               status: product.status === "Approved" ? "Rejected" : "Approved",
//             };
//           }
//           return product;
//         })
//       );
//     };
  
//     // Filter products based on selected filter
//     const filteredProducts =
//       filter === "All"
//         ? products
//         : products.filter((product) => product.status === filter);
  
//     return (
//       <div className="container mx-auto">
//         {/* Tabs Section */}
//         <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5 mt-5">
//           <button
//             onClick={() => setFilter("All")}
//             className={`flex flex-col items-center gap-1 ${
//               filter === "All" ? "text-green-600" : "text-gray-400"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <MdOutlineAccountBalanceWallet className="text-xl" />
//               <span className="font-semibold">All</span>
//             </div>
//             {filter === "All" && <div className="w-full h-1 bg-green-600"></div>}
//           </button>
  
//           <button
//             onClick={() => setFilter("Approved")}
//             className={`flex flex-col items-center gap-1 ${
//               filter === "Approved" ? "text-green-600" : "text-gray-400"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <FaUserCheck className="text-xl" />
//               <span className="font-medium">Approved</span>
//             </div>
//             {filter === "Approved" && (
//               <div className="w-full h-1 bg-green-600"></div>
//             )}
//           </button>
  
//           <button
//             onClick={() => setFilter("Rejected")}
//             className={`flex flex-col items-center gap-1 ${
//               filter === "Rejected" ? "text-green-600" : "text-gray-400"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <FaUserSlash className="text-xl" />
//               <span className="font-medium">Rejected</span>
//             </div>
//             {filter === "Rejected" && (
//               <div className="w-full h-1 bg-green-600"></div>
//             )}
//           </button>
  
//           <button
//             onClick={() => setFilter("Pending")}
//             className={`flex flex-col items-center gap-1 ${
//               filter === "Pending" ? "text-green-600" : "text-gray-400"
//             }`}
//           >
//             <div className="flex items-center gap-2">
//               <RxLapTimer className="text-xl" />
//               <span className="font-medium">Pending</span>
//             </div>
//             {filter === "Pending" && (
//               <div className="w-full h-1 bg-green-600"></div>
//             )}
//           </button>
//         </div>
  
//         {/* Table Section */}
//         <div className="overflow-x-auto mt-4 ">
//           <table className="w-full text-left">
//             <thead>
//               <tr>
//                 <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                   Item No
//                 </th>
//                 <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                   Company Name
//                 </th>
//                 <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                   Location
//                 </th>
//                 <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                   Brand
//                 </th>
//                 <th className="py-3 px-4 text-green-500 text-sm font-medium">
//                   Status
//                 </th>
//                 <th className="py-3 px-4"></th>
//               </tr>
//             </thead>
//             <tbody>
//     {filteredProducts.map((product, index) => (
//       <tr key={product.id} className="border-gray-300">
//         {/* Item Number (Index + 1) */}
//         <td className="py-3 px-4">
//           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//             {index + 1}
//           </div>
//         </td>
  
//         {/* Company Name */}
//         <td className="py-3 px-4">
//           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//             {product.company_name || "Name"}
//           </div>
//         </td>
  
//         {/* location */}
//         <td className="py-3 px-4">
//           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//             {product.location || "Name"}
//           </div>
//         </td>
//         {/* brand */}
//         <td className="py-3 px-4">
//           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//             {product.brand || "Name"}
//           </div>
//         </td>
  
//         {/* Status */}
//         <td className="py-3 px-4">
//           <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
//             {product.status || "Pending"}
//           </div>
//         </td>
  
//         {/* Action Buttons */}
//         <td className="py-3 px-4 ">
//           <button
//             onClick={() => handleStatusToggle(product.id)}
//             className={`${
//               product.status === "Approved"
//                 ? "text-red-600 border-red-600 hover:bg-red-100"
//                 : "text-green-600 border-green-600 hover:bg-green-100"
//             } border rounded-lg px-4 py-2 text-sm font-medium w-[100px]`}
//           >
//             {product.status === "Approved" ? "Reject" : "Approve"}
//           </button>
//           <Link
//             to={`/admin/approval/brands/view/${product.id}`}
//             className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100 ml-5"
//           >
//             View
//           </Link>
//         </td>
//       </tr>
//     ))}
//   </tbody>
  
//           </table>
//         </div>
//       </div>
//     );
//   }

// export default AdminBrands


import React, { useEffect, useState } from "react";
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { RxLapTimer } from "react-icons/rx";
import { FaUserCheck, FaUserSlash } from "react-icons/fa";
import axios from "axios";
import { BASE_URL, USER_URL } from "../../constant/api";
import { Link } from "react-router-dom";
import ConfirmationModal from "../../components/AdminApproval/ConfirmationModal";
import { ScaleLoader } from "react-spinners";  // Import ScaleLoader

function AdminBrands() {
  const [filter, setFilter] = useState("All");
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);   // Loading state
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [actionType, setActionType] = useState("");

  // Fetch products on component mount
  useEffect(() => {
    const fetchProducts = async () => {
      try {
        setLoading(true);  // Show loader while fetching
        const response = await USER_URL.get(`/products/admin/seller-brands/`);
        if (response.data?.Data) {
          setProducts(response.data.Data);
        }
      } catch (error) {
        console.error("Error fetching products:", error.message || error);
      } finally {
        setLoading(false);  // Hide loader after data is fetched
      }
    };
    fetchProducts();
  }, []);

  // Open the confirmation modal
  const openModal = (product, action) => {
    setSelectedProduct(product);
    setActionType(action);
    setModalOpen(true);
  };

  // Handle brand status update
  const handleConfirm = async () => {
    if (selectedProduct) {
      try {
        const newStatus = actionType === "Approve" ? "Approved" : "Rejected";
        await USER_URL.post(
          `/products/admin/seller-brands/${selectedProduct.id}/`,
          { status: newStatus }
        );

        // Update the UI immediately after API call
        setProducts((prevProducts) =>
          prevProducts.map((product) =>
            product.id === selectedProduct.id
              ? { ...product, status: newStatus }
              : product
          )
        );
      } catch (error) {
        console.error("Error updating status:", error.message || error);
      } finally {
        setModalOpen(false);
      }
    }
  };

  // Filter products based on selected filter
  const filteredProducts =
    filter === "All"
      ? products
      : products.filter((product) => product.status === filter);

  return (
    <div className="container mx-auto">
      {/* Tabs Section */}
      <div className="flex items-center justify-between border-b border-gray-300 w-full mb-5 mt-5">
        {["All", "Approved", "Rejected", "Pending"].map((status) => (
          <button
            key={status}
            onClick={() => setFilter(status)}
            className={`flex flex-col items-center gap-1 ${
              filter === status ? "text-green-600" : "text-gray-400"
            }`}
          >
            <div className="flex items-center gap-2">
              {status === "All" && <MdOutlineAccountBalanceWallet className="text-xl" />}
              {status === "Approved" && <FaUserCheck className="text-xl" />}
              {status === "Rejected" && <FaUserSlash className="text-xl" />}
              {status === "Pending" && <RxLapTimer className="text-xl" />}
              <span className="font-semibold">{status}</span>
            </div>
            {filter === status && (
              <div className="w-full h-1 bg-green-600"></div>
            )}
          </button>
        ))}
      </div>

      {/* Loader Section */}
      {loading ? (
        <div className="flex justify-center items-center h-96">
          <ScaleLoader color="#FFAE00" height={40} />
        </div>
      ) : (
        <>
          {/* Table Section */}
          <div className="overflow-x-auto mt-4">
            <table className="w-full text-left">
              <thead>
                <tr>
                  <th className="py-3 px-4 text-green-500 text-sm font-medium">
                    Item No
                  </th>
                  <th className="py-3 px-4 text-green-500 text-sm font-medium">
                    Company Name
                  </th>
                  <th className="py-3 px-4 text-green-500 text-sm font-medium">
                    Location
                  </th>
                  <th className="py-3 px-4 text-green-500 text-sm font-medium">
                    Brand
                  </th>
                  <th className="py-3 px-4 text-green-500 text-sm font-medium">
                    Status
                  </th>
                  <th className="py-3 px-4"></th>
                </tr>
              </thead>
              <tbody>
                {filteredProducts.map((product, index) => (
                  <tr key={product.id} className="border-gray-300">
                    <td className="py-3 px-4">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {index + 1}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.company_name || "Name"}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.location || "Location"}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div className="rounded-lg border border-gray-300 px-4 py-2 text-gray-800 text-sm">
                        {product.brand || "Brand"}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <div
                        className={`rounded-lg border px-4 py-2 text-sm ${
                          product.status === "Approved"
                            ? "text-green-600 border-green-600"
                            : product.status === "Rejected"
                            ? "text-red-600 border-red-600"
                            : "text-yellow-600 border-yellow-600"
                        }`}
                      >
                        {product.status || "Pending"}
                      </div>
                    </td>
                    <td className="py-3 px-4">
                      <button
                        onClick={() =>
                          openModal(
                            product,
                            product.status === "Approved" ? "Reject" : "Approve"
                          )
                        }
                        className={`${
                          product.status === "Approved"
                            ? "text-red-600 border-red-600 hover:bg-red-100"
                            : "text-green-600 border-green-600 hover:bg-green-100"
                        } border rounded-lg px-4 py-2 text-sm font-medium w-[100px]`}
                      >
                        {product.status === "Approved" ? "Reject" : "Approve"}
                      </button>
                      <Link
                        to={`/admin/approval/brands/view/${product.id}`}
                        className="text-green-600 border border-green-600 rounded-lg px-4 py-2 text-sm font-medium hover:bg-green-100 ml-5"
                      >
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </>
      )}

      {/* Confirmation Modal */}
      <ConfirmationModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={handleConfirm}
        action={actionType}
        product={selectedProduct}
      />
    </div>
  );
}

export default AdminBrands;
